import React from 'react';
import { useTranslation } from 'react-i18next';

export default function NotFound404() {
  const { t } = useTranslation('notFound');

  return <div>{t('err')}</div>;
}
